import { render } from "./HistoryRow.vue?vue&type=template&id=612596d3&scoped=true"
import script from "./HistoryRow.vue?vue&type=script&lang=js"
export * from "./HistoryRow.vue?vue&type=script&lang=js"

import "./HistoryRow.vue?vue&type=style&index=0&id=612596d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612596d3"]])

export default __exports__